import { Injectable } from '@angular/core';
import {
  Action,
  State,
  Selector,
  StateContext, createSelector,
} from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { EventsStateActions } from './events-state.actions';
import { EventsStateModel } from './events-state.models';
import { DbrEventEntity } from '@balloon-race-fullstack-monorepo/dbr-rest-api';

const STATE_NAME = 'EventsState';

@State<EventsStateModel>({
  name: STATE_NAME,
  defaults: {
    events: [],
    activeEventId: null,
  },
})
@Injectable()
export class EventsState {
  @Selector()
  static events(state: EventsStateModel): DbrEventEntity[] | null {
    return state.events;
  }

  @Selector()
  static activeEventId(state: EventsStateModel): number | null {
    return state.activeEventId;
  }

  static eventById(id: number) {
    return createSelector([EventsState], (state: EventsStateModel): DbrEventEntity | undefined => {
      if (state.events && state.events.length) {
        return state.events.find((item) => item.id === id);
      } else {
        return undefined;
      }
    });
  }

  @Action(EventsStateActions.SetEvent)
  setEvent(ctx: StateContext<EventsStateModel>, action: EventsStateActions.SetEvent) {
    const state = ctx.getState();
    const newListEvents = JSON.parse((JSON.stringify(state.events)));
    const index = state.events.findIndex((item) => item.id === action.event.id);
    if (index > -1) {
      newListEvents[index] = action.event;
    } else {
      newListEvents.push(action.event);
    }

    ctx.setState(patch<EventsStateModel>({
      events: newListEvents,
    }));
  }

  @Action(EventsStateActions.SetEvents)
  setEvents(ctx: StateContext<EventsStateModel>, action: EventsStateActions.SetEvents) {
    ctx.setState(patch<EventsStateModel>({
      events: action.events,
    }));
  }

  @Action(EventsStateActions.SetActiveEventId)
  setActiveEventId(ctx: StateContext<EventsStateModel>, action: EventsStateActions.SetActiveEventId) {
    ctx.setState(patch<EventsStateModel>({
      activeEventId: action.activeEventId,
    }));
  }
}

